import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';
import { AUTOMATION_QUERY_KEYS } from '../queryKeys';
import { invalidateAllAutomationTemplatesQueries } from './useAutomationTemplatesQuery';

export function useAutomationTemplateQuery({
	id,
	enabled = true,
	impersonationContext,
}: {
	id: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!id,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationTemplate>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `automationTemplate/${encodeURIComponent(id)}`,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [
			...AUTOMATION_QUERY_KEYS.template(id),
			impersonationContext?.account?.id,
			impersonationContext?.user?.id,
		],
	});
}

export function invalidateAutomationTemplateQuery(templateId: string) {
	reactQueryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.template(templateId) });
}

/**
 * @deprecated Use invalidateAllAutomationTemplatesQueries from useAutomationTemplatesQuery instead
 */
export function invalidateAllAutomationTemplateQueries() {
	invalidateAllAutomationTemplatesQueries();
}
